import React, { useEffect, useState, useCallback } from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useLoader } from '../../contexts/LoaderContext';
import { LOADER_TIPS } from '../../constants/loaderTips';
import './GlobalLoader.css';

const GlobalLoader = () => {
  const { isLoading, isTransitioning, title, subText } = useLoader();
  const [currentTip, setCurrentTip] = useState('');
  const [isVisible, setIsVisible] = useState(false);

  const updateVisibility = useCallback(() => {
    if (isLoading || isTransitioning) {
      setIsVisible(true);
    } else {
      // Add a small delay before hiding to ensure smooth transition
      setTimeout(() => {
        setIsVisible(false);
      }, 300);
    }
  }, [isLoading, isTransitioning]);

  useEffect(() => {
    updateVisibility();
  }, [isLoading, isTransitioning, updateVisibility]);

  useEffect(() => {
    if (isVisible) {
      // Set initial tip
      const randomIndex = Math.floor(Math.random() * LOADER_TIPS.length);
      setCurrentTip(LOADER_TIPS[randomIndex]);

      // Change tip every 5 seconds
      const interval = setInterval(() => {
        const newIndex = Math.floor(Math.random() * LOADER_TIPS.length);
        setCurrentTip(LOADER_TIPS[newIndex]);
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div className={`global-loader-overlay ${!isLoading ? 'fade-out' : ''}`}>
      <div className="global-loader-content">
        <ProgressSpinner 
          strokeWidth="4"
          fill="var(--surface-ground)"
          animationDuration=".5s"
        />
        <h2 className="global-loader-title">{title}</h2>
        {subText && <p className="global-loader-subtext">{subText}</p>}
        <div className="global-loader-tip">
          <p>{currentTip}</p>
        </div>
      </div>
    </div>
  );
};

export default GlobalLoader; 